const Overlay = ({ isOpen }: { isOpen: boolean }) => (
    <div
        className={`fixed bottom-0 left-0 right-0 top-0 z-40 h-full w-full transition-all delay-100 duration-[400ms] ${
            isOpen
                ? 'visible bg-black/40 backdrop-blur-sm'
                : 'invisible bg-black/0 backdrop-blur-none'
        }`}
    />
);

export default Overlay;
